import { collection, doc, getDoc, getDocs, query } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { SchoolView } from "../Types/SchoolSchema";

export async function getAllSchools(): Promise<SchoolView[]> {
    const schools: SchoolView[] = [];

    const schoolQuery = query(collection(db, "School"));
    const queryResult = await getDocs(schoolQuery);
    queryResult.forEach((doc) => {
        schools.push(
            {
                Id: doc.id,
                Name: doc.data().Name,
                FullName: doc.data().FullName,
                Address: doc.data().Address,
                SchoolIcon: doc.data().SchoolIcon,
            } as SchoolView);
    });
    return schools;
}

export async function getSchool(schoolId: string): Promise<SchoolView | undefined> {
    const schoolRef = doc(db, "School", schoolId);
    const school = await getDoc(schoolRef);
    if (school.exists()) {
        return {
            Id: school.id,
            Name: school.data().Name,
            FullName: school.data().FullName,
            Address: school.data().Address,
            SchoolIcon: school.data().SchoolIcon,
        } as SchoolView;
    }
    return undefined;
}